import angular from 'angular';
import moment from 'moment';
import { Empresa } from '../../../../../../../core/usuario/models/usuario-model';
import { ListagemService } from '../../../../../../../shared/services/listagem.service';
import { ApuracoesPontoService } from '../../../../ApuracoesPonto/apuracoesponto.service';
import { IApuracaoPonto, IApuracaoSelectItem } from '../../../../models/apuracaoponto.model';
import { GeracaoDeMarcacoesPadraoService } from '../../../geracao-de-marcacoes-padrao.service';
import { IGeracaoDeMarcacoesPadraoHistoricosDisponiveis } from '../../../models/geracao-de-marcacoes-padrao.service.model';
import { IGeracaoDeMarcacoesPadraoForm, IHistoricoDisponivelSelectItem } from '../../models/geracao-de-marcacoes-padrao.form.model';

export class PeriodoDeApuracaoFormController {

    static $inject = [
        '$scope',
        '$rootScope',
        'ListagemService',
        'ApuracoesPontoService',
        'GeracaoDeMarcacoesPadraoService',
    ];

    public form: angular.IFormController;
    public editable = false;
    public entity: IGeracaoDeMarcacoesPadraoForm;

    public empresas: Empresa[] = [];
    public apuracoes: IApuracaoPonto[] = [];
    public apuracoesSelect: IApuracaoSelectItem[] = [];
    public apuracaoSelecionada: IApuracaoSelectItem | null = null;
    public historicosDisponiveis: IGeracaoDeMarcacoesPadraoHistoricosDisponiveis[] = [];
    public historicosDisponiveisSelect: IHistoricoDisponivelSelectItem[] = [];
    public sincronizandoDatasApuracao = false;

    public busy = false;
    public loadingApuracoes = false;
    public loadingHistoricos = false;

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            session: any,
            nsjGlobals: any,
        },
        public ListagemService: ListagemService,
        public ApuracoesPontoService: ApuracoesPontoService,
        public GeracaoDeMarcacoesPadraoService: GeracaoDeMarcacoesPadraoService,
    ) {
        this.$scope.$on('apuracoesponto_index_loaded', (event, args: IApuracaoPonto[]) => {
            if (this.ApuracoesPontoService.loadParams.finished ||
                this.ApuracoesPontoService.loadParams.to_load === 0
            ) {
                this.apuracoes = angular.copy(args || []);
                this.montaApuracaoSelect();
                this.loadingApuracoes = false;
                this.syncBusy();
            }
        });

        this.$scope.$on('ponto_importacoesmarcacoes_historicos_disponiveis_loaded', (_event, historicos: IGeracaoDeMarcacoesPadraoHistoricosDisponiveis[]) => {
            this.historicosDisponiveis = angular.copy(historicos || []);
            this.montaHistoricosDisponiveisSelect();
            this.sincronizaHistoricoSelecionado();
            this.loadingHistoricos = false;
            this.syncBusy();
        });

        this.$scope.$on('ponto_importacoesmarcacoes_historicos_disponiveis_error', () => {
            this.historicosDisponiveis = [];
            this.montaHistoricosDisponiveisSelect();
            this.sincronizaHistoricoSelecionado();
            this.loadingHistoricos = false;
            this.syncBusy();
        });
    }

    $onInit() {
        this.entity = this.entity || {} as IGeracaoDeMarcacoesPadraoForm;
        this.entity.historico = angular.isUndefined(this.entity.historico) ? null : this.entity.historico;
        this.entity.justificativa = angular.isUndefined(this.entity.justificativa) ? '' : this.entity.justificativa;
        this.montaHistoricosDisponiveisSelect();
        this.sincronizaHistoricoSelecionado();

        this.carregaEmpresas();
        this.defineEmpresaPadrao();
        this.observeEmpresa();
        this.observeApuracao();
        this.observeDatas();
        this.observeHistorico();
        this.carregaHistoricosDisponiveis();

        if (this.entity.empresa) {
            this.carregaApuracoes();
        }
    }

    carregaEmpresas() {
        this.empresas = this.ListagemService.montaEmpresas(
            this.$rootScope.nsjGlobals.a.grupoempresarial,
            [],
        );
    }

    defineEmpresaPadrao() {
        if (!this.entity.empresa) {
            this.entity.empresa = this.$rootScope.session?.entities?.empresa?.empresa || '';
        }
    }

    observeEmpresa() {
        this.$scope.$watch(
            () => this.entity?.empresa,
            (newValue?: string, oldValue?: string) => {
                if (newValue === oldValue) {
                    return;
                }

                this.apuracaoSelecionada = null;
                this.apuracoes = [];
                this.apuracoesSelect = [];
                this.entity.apuracaoponto = '';
                this.entity.apuracao_selecionada_label_ui = '';
                this.entity.datainicial = '';
                this.entity.datafinal = '';

                if (!newValue) {
                    return;
                }

                this.carregaApuracoes();
            },
        );
    }

    observeApuracao() {
        this.$scope.$watch(
            () => this.entity?.apuracaoponto,
            (newValue?: string, oldValue?: string) => {
                if (newValue === oldValue) {
                    return;
                }

                this.sincronizaApuracaoSelecionada();
            },
        );
    }

    observeDatas() {
        this.$scope.$watch(
            () => this.entity?.datainicial,
            (newValue?: string, oldValue?: string) => {
                if (newValue === oldValue) {
                    return;
                }

                this.validaDataNoPeriodo('datainicial');
            },
        );

        this.$scope.$watch(
            () => this.entity?.datafinal,
            (newValue?: string, oldValue?: string) => {
                if (newValue === oldValue) {
                    return;
                }

                this.validaDataNoPeriodo('datafinal');
            },
        );
    }

    observeHistorico() {
        this.$scope.$watch(
            () => this.entity?.historico,
            (newValue, oldValue) => {
                if (newValue === oldValue) {
                    return;
                }

                this.sincronizaHistoricoSelecionado();

                if (newValue !== null) {
                    this.entity.justificativa = '';
                }
            },
        );
    }

    carregaApuracoes() {
        this.loadingApuracoes = true;
        this.syncBusy();
        this.ApuracoesPontoService.constructors = {};
        this.ApuracoesPontoService.constructors['vigente'] = false;
        this.ApuracoesPontoService.constructors['empresa'] = this.entity.empresa;
        this.ApuracoesPontoService.constructors['estabelecimento'] = '';
        this.apuracoes = this.ApuracoesPontoService.reload();
    }

    carregaHistoricosDisponiveis() {
        this.loadingHistoricos = true;
        this.syncBusy();
        this.GeracaoDeMarcacoesPadraoService.getHistoricosDisponiveis();
    }

    montaApuracaoSelect() {
        this.apuracoesSelect = this.apuracoes
            .filter((apuracao) => this.isApuracaoElegivelParaSelect(apuracao))
            .map((apuracao) => {
                return {
                    periodo: this.formatApuracaoSelecionadaLabel(apuracao),
                    inicioapuracao: apuracao.inicioapuracao,
                    terminoapuracao: apuracao.terminoapuracao,
                    apuracaoponto: apuracao.apuracaoponto,
                    referencia: this.getReferenciaApuracao(apuracao),
                    status: apuracao.status,
                };
            });

        this.sincronizaApuracaoSelecionada();
    }

    montaHistoricosDisponiveisSelect() {
        this.historicosDisponiveisSelect = [
            {
                historico: null,
                descricao: 'Outros',
            },
            ...this.historicosDisponiveis.map((historico) => ({
                historico: historico.historico,
                descricao: historico.descricao,
            })),
        ];
    }

    sincronizaHistoricoSelecionado() {
        const historicoSelecionado = this.historicosDisponiveisSelect.find((historico) => (
            historico.historico === this.entity.historico
        ));

        this.entity.historico_selecionado_label_ui = historicoSelecionado?.descricao || '';
    }

    formatApuracaoSelecionadaLabel(apuracao: IApuracaoPonto) {
        return `${moment(apuracao.inicioapuracao).format('DD/MM/YYYY')} a ${moment(apuracao.terminoapuracao).format('DD/MM/YYYY')} ${this.getApuracaoReferenciaLabel(apuracao)}`.trim();
    }

    getApuracaoReferenciaLabel(apuracao: IApuracaoPonto) {
        if (apuracao.trabalhadorobj?.trabalhador) {
            return `- Trabalhador: ${apuracao.trabalhadorobj.nome}`;
        }

        if (apuracao.lotacaoobj?.lotacao) {
            return `- Lotação: ${apuracao.lotacaoobj.nome}`;
        }

        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return `- Estabelecimento: ${apuracao.estabelecimentoobj.nomefantasia}`;
        }

        if (apuracao.empresaobj?.empresa) {
            return `- Empresa: ${apuracao.empresaobj.razaosocial}`;
        }

        return '';
    }

    getReferenciaApuracao(apuracao: IApuracaoPonto) {
        if (apuracao.trabalhadorobj?.trabalhador) {
            return { trabalhador: apuracao.trabalhadorobj.trabalhador };
        }

        if (apuracao.lotacaoobj?.lotacao) {
            return { lotacao: apuracao.lotacaoobj.lotacao };
        }

        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return { estabelecimento: apuracao.estabelecimentoobj.estabelecimento };
        }

        if (apuracao.empresaobj?.empresa) {
            return { empresa: apuracao.empresaobj.empresa };
        }

        return null;
    }

    onApuracaoChange() {
        this.sincronizaApuracaoSelecionada();

        if (!this.apuracaoSelecionada) {
            this.entity.datainicial = '';
            this.entity.datafinal = '';
            return;
        }

        this.sincronizandoDatasApuracao = true;
        this.entity.datainicial = this.apuracaoSelecionada.inicioapuracao;
        this.entity.datafinal = this.getDataLimiteApuracao();
        this.$scope.$evalAsync(() => {
            this.sincronizandoDatasApuracao = false;
        });
    }

    sincronizaApuracaoSelecionada() {
        this.apuracaoSelecionada = this.apuracoesSelect.find((apuracao) => (
            apuracao.apuracaoponto === this.entity.apuracaoponto
        )) || null;

        this.entity.apuracao_selecionada_label_ui = this.apuracaoSelecionada?.periodo || '';

        if (!this.apuracaoSelecionada && this.entity.apuracaoponto) {
            this.entity.apuracaoponto = '';
        }
    }

    getDataLimiteApuracao() {
        if (!this.apuracaoSelecionada) {
            return '';
        }

        const dataHoje = moment().startOf('day');
        const inicioApuracao = moment(this.apuracaoSelecionada.inicioapuracao, 'YYYY-MM-DD', true).startOf('day');
        const terminoApuracao = moment(this.apuracaoSelecionada.terminoapuracao, 'YYYY-MM-DD', true).endOf('day');

        if (!inicioApuracao.isValid() || !terminoApuracao.isValid()) {
            return this.apuracaoSelecionada.terminoapuracao;
        }

        if (dataHoje.isBetween(inicioApuracao, terminoApuracao, undefined, '[]')) {
            return dataHoje.format('YYYY-MM-DD');
        }

        return this.apuracaoSelecionada.terminoapuracao;
    }

    validaDataNoPeriodo(campo: 'datainicial' | 'datafinal') {
        const data = this.entity?.[campo];

        if (this.sincronizandoDatasApuracao || !this.apuracaoSelecionada || !data) {
            return;
        }

        const dataMoment = moment(data, 'YYYY-MM-DD', true);
        const inicioApuracao = moment(this.apuracaoSelecionada.inicioapuracao, 'YYYY-MM-DD', true);
        const dataLimiteApuracao = moment(this.getDataLimiteApuracao(), 'YYYY-MM-DD', true);
        const dataInicial = this.entity.datainicial
            ? moment(this.entity.datainicial, 'YYYY-MM-DD', true)
            : null;
        const dataFinal = this.entity.datafinal
            ? moment(this.entity.datafinal, 'YYYY-MM-DD', true)
            : null;

        const foraDoPeriodo = !dataMoment.isValid() ||
            !dataMoment.isBetween(inicioApuracao, dataLimiteApuracao, 'day', '[]');
        const ordemInvalida = !!dataInicial && !!dataFinal && dataInicial.isAfter(dataFinal);

        if (foraDoPeriodo || ordemInvalida) {
            this.entity[campo] = '';
        }
    }

    private isApuracaoElegivelParaSelect(apuracao: IApuracaoPonto) {
        const inicioApuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD', true).startOf('day');
        const dataHoje = moment().startOf('day');

        return inicioApuracao.isValid() && !inicioApuracao.isAfter(dataHoje);
    }

    private syncBusy() {
        this.busy = this.loadingApuracoes || this.loadingHistoricos;
    }
}
